import axios from "axios";
import debounce from "lodash/debounce";

import createMentionPlugin from "./draft-js-mention-plugin";
import SuggestionEntry from "./SuggestionEntry";
import mentionPluginTheme from "./styles/mentionsPluginTheme.sass";

export default ({ getWrapper = () => {}, setSuggestions = () => {} }) => {
  const getPositionSuggestions = ({ decoratorRect, popover }) => {
    const editorRect = getWrapper().getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const style = { top: `${(decoratorRect.bottom - editorRect.top) + 6}px` };

    if (decoratorRect.left + popoverRect.width <= editorRect.right - 12) {
      style.left = `${decoratorRect.left - editorRect.left}px`;
    } else {
      style.right = "12px";
    }

    return style;
  };

  const transformSuggestions = suggestions => suggestions.map(suggestion => (
    ({ title: name, url: link, class: type, info, poster, class_id: id }) => ({ name, link, type, info, poster, id })
  )(suggestion));

  const onSearchChange = ({ value }) => {
    if (value.length < 1) return;
    axios.get(`/api/search?q=${value}&type=suggest`)
      .then(({ data }) => {
        setSuggestions(transformSuggestions(data));
      });
  };

  const mentionPlugin = createMentionPlugin({
    theme: mentionPluginTheme,
    positionSuggestions: getPositionSuggestions,
    supportWhitespace: true,
    mentionRegExpAllows: /[\w\s\x7f-\xff.-:]+/,
  });

  return Object.assign(
    mentionPlugin,
    {
      SuggestionEntry,
      onSearchChange: debounce(onSearchChange, 100),
    },
  );
};
